import {
    getDimensionsFromSvg,
    readFileAsString,
} from '../../illustrations/utils/illustrationTransformationUtils';

const ICON_NAME_REGEX = /[^a-z_]|^ic_|_ic_|^ic/g;

export function validIconName(iconName) {
    return iconName && !iconName.match(ICON_NAME_REGEX);
}

export function getIconNameError(iconName) {
    if (!iconName) {
        return 'Icon name cannot be empty';
    }

    if (iconName.match(/[A-Z]/g)) {
        return 'Uppercase characters not allowed';
    }

    if (iconName.match(/[\d]/g)) {
        return 'Numeric characters not allowed';
    }

    if (iconName.match(/[^a-z_]/g)) {
        return 'Special characters except _ not allowed';
    }

    if (iconName.match(/^ic_/g)) {
        return `Icon name shouldn't start with ic_`;
    }

    if (iconName.match(/^ic/g)) {
        return `Icon name shouldn't start with ic`;
    }

    if (iconName.match(/_ic_/g)) {
        return `Icon name shouldn't contain characters _ic_`;
    }
}

export async function validIconFileSize(iconFile, iconSize) {
    iconSize = parseInt(iconSize);
    // If icon is null return false
    if (!iconFile) {
        return false;
    }

    // Read the icon file as a string
    const fileAsString = await readFileAsString(iconFile);
    // Get dimensions of the icon file
    var dimensions = getDimensionsFromSvg(fileAsString);
    console.log(typeof dimensions.width);
    // If dimenstions are not equal to icon size, return false
    if (dimensions.width !== iconSize || dimensions.height !== iconSize) {
        return false;
    }

    // Icon file is of valid size, return true
    return true;
}
